import { Button } from '@/components/ui/button';
import { ChevronDownIcon, CopyIcon } from 'lucide-react';
import { toast } from 'sonner';

interface CustomTemplateZipGuideProps {
	hints: readonly string[];
	prompt: string;
}

export default function CustomTemplateZipGuide({ hints, prompt }: CustomTemplateZipGuideProps) {
	function copyAiPrompt() {
		navigator.clipboard
			.writeText(prompt)
			.then(() => toast.success('Промпт скопирован'))
			.catch(() => toast.error('Ошибка копирования'));
	}

	return (
		<details className='mb-3 rounded-lg border border-border bg-muted/30 px-3 py-2 group'>
			<summary className='flex cursor-pointer list-none items-center justify-between gap-2 text-sm font-medium [&::-webkit-details-marker]:hidden'>
				Как подготовить ZIP
				<ChevronDownIcon className='size-4 shrink-0 text-muted-foreground transition-transform group-open:rotate-180' />
			</summary>
			<div className='pt-2 text-xs text-muted-foreground space-y-3'>
				{hints.map(hint => (
					<p key={hint}>• {hint}</p>
				))}
				<Button type='button' variant='outline' size='sm' onClick={copyAiPrompt}>
					<CopyIcon size={14} className='mr-1' />
					Скопировать промпт для ИИ
				</Button>
			</div>
		</details>
	);
}
